import { Box, Card } from "@mui/material";
import { TitleUnderlineComponent } from "pages/LandingPages/OtherPages/components/Title";

// eslint-disable-next-line react/prop-types
export const SucursalesMap = ({ map }) => {
  return (
    <Card
      sx={{
        my: 4,
        borderRadius: 0,
        p: 3,
        mx: -3,
        background: "linear-gradient(145deg,rgb(255, 255, 255), #ffffff)",
        boxShadow: "13px 13px 26px #d9d9d9, -13px -13px 26px #ffffff",
      }}
    >
      <TitleUnderlineComponent variant={"h3"} title={"PLUS en Ecuador"} align={"center"} />
      <Box display="flex" justifyContent="center" alignItems="center" py={4}>
        <img
          src={`data:image/webp;base64,${map}`}
          alt="Plus Ecuador"
          style={{
            width: "100%",
            maxWidth: "800px",
            height: "auto",
          }}
          loading="lazy"
        />
      </Box>
    </Card>
  );
};
